import {makeAutoObservable, observable} from 'mobx';

class LanguageToggleStore {
    // Сайт тимчасово доступний лише українською — мову зафіксовано на "ua".
    // Значення з localStorage навмисно ігнорується, щоб користувачі, які раніше
    // обрали "en", також бачили українську версію. Перемикач мов приховано в хедері.
    activeLanguage = "ua";

    constructor() {
        makeAutoObservable(this, {
            activeLanguage: observable
        });
    }

    async changeLang(lang: string) {
        // Зміну мови вимкнено, поки перемикач приховано.
        // localStorage.setItem("lang", lang)
        // this.activeLanguage = lang;
    }
}

export const languageToggleStore = new LanguageToggleStore();